// Middleware til at håndtere localStorage persistence
export const persistenceMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  
  // Gem auth state til localStorage
  if (action.type.startsWith('auth/')) {
    const authState = store.getState().auth;
    if (authState.isAuthenticated) {
      localStorage.setItem('token', authState.token);
    } else {
      localStorage.removeItem('token');
    }
  }
  
  // Gem mate state til localStorage
  if (action.type.startsWith('mate/') && action.type !== 'mate/loadMateFromStorage') {
    const mateState = store.getState().mate;
    if (mateState.currentUser) {
      localStorage.setItem('user', JSON.stringify(mateState.currentUser));
    } else {
      localStorage.removeItem('user');
    }
  }
  
  // Gem game state til localStorage
  if (action.type.startsWith('game/') && action.type !== 'game/loadGameFromStorage') {
    const gameState = store.getState().game;
    const gameData = {
      preseasonWinner: gameState.preseasonWinner,
      leagueStanding: gameState.leagueStanding,
      playoffPredictions: gameState.playoffPredictions,
      knockoutPredictions: gameState.knockoutPredictions,
      finalPrediction: gameState.finalPrediction,
      points: gameState.points,
      gameStarted: gameState.gameStarted,
      currentPhase: gameState.currentPhase,
    };
    localStorage.setItem('championsLeagueGame', JSON.stringify(gameData));
  }
  
  return result;
};
